import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import authSlice from "@slices/auth.slice";
import modalSlice from "@slices/modal.slice";

const FooterModal: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const openLoginModal = () => {
    dispatch(
      authSlice.actions.passAuth({
        loginCompleted: false,
        passwordSection: false,
      })
    );
    dispatch(modalSlice.actions.updateRegisterModal(false));
    dispatch(modalSlice.actions.updateLoginModal(true));
  };
  return (
    <div className="container" data-testid={"footer-modal-test"}>
      <div className="row">
        <div className="col-sm-12">
          <div className="fg-modal-msg-content">
            <p data-testid={"alreadyHaveAnAccount"}>
              {t("alreadyHaveAnAccount")}
              <button
                data-testid="sign-in"
                className="fg-button-override"
                onClick={openLoginModal}
              >
                {t("signIn")}
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterModal;
